
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export const searchFormItems = [
  createFormItem('姓名', 'name', FORM_ITEM.INPUT, {placeholder:'姓名', maxlength:'30',clearable:'true', }),
  createFormItem('手机', 'telPhone', FORM_ITEM.INPUT, {placeholder:'手机', maxlength:'11',clearable:'true', }),
  createFormItem('船号', 'shipNum', FORM_ITEM.INPUT, {placeholder:'船号', maxlength:'50',clearable:'true', }),
  createFormItem('登录许可', 'loginPermission', FORM_ITEM.SELECT, {loader: 'CL_ALLOW',allOption: true, }),
]

export const editFormItems = [
]

export const addFormItems = [
]

export const addRules = {
}
export const editRules = {
}